import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  link: {
    fontStyle: 'normal',
    fontWeight: 500,
    verticalAlign: 'initial',
    fontSize: '1em',
    '&.primary': {
      color: theme.palette.primary.main,
    },
    '&.secondary': {
      color: '#ffffff',
    },
    '&.primary:disabled, &.secondary:disabled, &.primary.is-disabled, &.secondary.is-disabled': {
      color: '#9aa5b1',
      cursor: 'not-allowed',
      opacity: 0.7,
      pointerEvents: 'none',
      textDecoration: 'none',
    },
  },
}));

const ButtonLink = ({ type = 'primary', text, disabled, onClick }) => {
  const classes = useStyles();
  return (
    <Link
      className={`${classes.link} ${type}${disabled ? ' is-disabled' : ''}`}
      component="button"
      type="button"
      onClick={event => {
        if (disabled) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        onClick?.(event);
      }}
      disabled={disabled}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      underline={disabled ? 'none' : 'always'}
    >
      {!!text && text}
    </Link>
  );
};

ButtonLink.propTypes = {
  type: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ButtonLink;
